<template>
    <div class="related-fares-list">
        <v-container class="related-fares-list-container">
            <v-btn
                class="btn-back"
                :to="{name: 'pointOfSaleList'}"
            >
                <v-icon>mdi-arrow-left</v-icon> Voltar
            </v-btn>
            <list-related-fares />
        </v-container>
    </div>
</template>

<script>
import ListRelatedFares from "../../components/PointOfSale/ListRelatedFares";

export default {
    name: "relatedFaresList",
    components: {ListRelatedFares}
}
</script>

<style lang="scss" scoped>
.related-fares-list {
    background-color: #f0f0f0;
    height: 100%;
    &-container {
        width: 90%;
        padding-top: 80px;
        position: relative;
    }
}

.btn-back {
    position: absolute;
    left: 12px;
    top: 20px;
}

</style>
